import styled from "styled-components";

export const ChecklistPageContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0px 48px;
    width: 100%;
`

export const OutletContainer = styled.div`
    margin-bottom: 48px;
    width: ${(props) => props.$width};
`